import React, { Component } from 'react';

import { chevronForwardOutline as go } from 'ionicons/icons';
import {
  withIonLifeCycle,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
} from '@ionic/react';

class PrescriptionTypeSelector extends Component {
  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/home" />
            </IonButtons>

            <IonTitle>Invia Ricetta</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonGrid className="ion-padding-top">
            <IonRow className="ion-padding-bottom">
              <IonCol className="ion-align-self-center">
                <h2 className="text-center">Seleziona il metodo di invio ricetta</h2>
              </IonCol>
            </IonRow>

            <IonRow className="ion-padding-bottom">
              <IonCol className="ion-align-self-center">
                <IonButton
                  color="light"
                  size="large"
                  expand="block"
                  onClick={() => {
                    this.props.history.push('/app/prescription-request/new/fse');
                  }}
                >
                  Fascicolo <br /> Sanitario
                  <IonIcon icon={go} slot="end" />
                </IonButton>
              </IonCol>
            </IonRow>

            <IonRow className="ion-padding-bottom">
              <IonCol className="ion-align-self-center">
                <IonButton
                  color="light"
                  size="large"
                  expand="block"
                  onClick={() => {
                    this.props.history.push('/app/prescription-request/new/nre');
                  }}
                >
                  Numero Ricetta <br /> (NRE)
                  <IonIcon icon={go} slot="end" />
                </IonButton>
              </IonCol>
            </IonRow>

            <IonRow className="ion-padding-bottom">
              <IonCol className="ion-align-self-center">
                <IonButton
                  color="light"
                  size="large"
                  expand="block"
                  onClick={() => {
                    this.props.history.push('/app/prescription-request/new/file');
                  }}
                >
                  Carica File <br /> o Foto
                  <IonIcon icon={go} slot="end" />
                </IonButton>
              </IonCol>
            </IonRow>

            <IonRow className="ion-padding-top">
              <IonCol className="ion-align-self-center">
                <IonButton
                  fill="clear"
                  expand="block"
                  onClick={() => {
                    this.props.history.push('/app/prescription-request/list');
                  }}
                >
                  Vedi storico ricette
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(PrescriptionTypeSelector);
